import { createContext } from 'preact/compat';
export const optionsDefaults = {
    analyticsTitle: 'Add to Wallet',
    analyticsUrl: 'https://www.snowdome.co.uk/',
    analyticsPath: '/',
    products: [],
    title: undefined,
};
export const OptionsCTX = createContext(optionsDefaults);
